import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {Brand, Product} from 'src/app/shared/models/models';
import { ProductService } from 'src/app/configuration/services/product.service';
import {BrandService} from "./services/brand.service";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {BrandEditComponent} from "./brand/brand-edit/brand-edit.component";
import {NGXLogger} from "ngx-logger";
import {AuthService} from "../core/auth/auth.service";
import {Permissions} from "../core/auth/permissions";
import {FacadeService} from "../shared/services/facade.service";
import { take } from 'rxjs';
import { DeleteDialogComponent } from '../shared/components/delete-dialog/delete-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { LoadingDialogService } from '../shared/services/loading-dialog.service';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})

export class ConfigurationComponent implements OnInit {
  brands: Array<Brand> = [];
  selectedBrandId! : number;
  settingsTitle : string = "Global Settings";

  allowBrandCreate : boolean = false;
  allowBrandEdit : boolean = false;
  allowBrandDelete : boolean = false;

  constructor(public dialog: MatDialog,
              private productService : ProductService,
              private brandService : BrandService,
              public router: Router,
              private httpClient : HttpClient,
              private logger: NGXLogger,
              private authService : AuthService,
              private facadeService: FacadeService,
              private toastr: ToastrService,
              private loadingDialogService: LoadingDialogService) {
    this.facadeService.setPageTitleContext(this.settingsTitle);
  }

  /**
   * Init
   */
  ngOnInit(): void {
    this.brandService.getBrands().then( ( brands ) => {
      this.brands = brands.sort((a, b) => a.id - b.id);
      }
    );

    this.authService.role.pipe(take(1)).subscribe(role => {
      let accessPermissionList : string[] = this.authService.getAccessPermissions(role);

      if(accessPermissionList.includes(Permissions.Type.ADD_NEW_BRAND)) { this.allowBrandCreate = true; }
      if(accessPermissionList.includes(Permissions.Type.EDIT_BRAND)) { this.allowBrandEdit = true; }
      if(accessPermissionList.includes(Permissions.Type.DELETE_BRAND)) { this.allowBrandDelete = true; }
    });
  }

  /**
   * Edit brand
   * @param brand Brand to edit
   */
  // edit(brand : Brand): void {
  //   this.logger.debug("Editing Product:" + JSON.stringify(brand));
  //   this.productService.loadProducts(brand.products);
  //   this.router.navigate(['/configuration/brand/'+ brand.id]);
  // }

  /**
   * Add brand
   */
  add() {
    let brand = new Brand(0, "", new Array<Product>());
    let dialogRef = this.dialog.open(BrandEditComponent, {
      data: { product: brand, title : "Add Brand" },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.logger.debug(`Dialog result: ${JSON.stringify(result)}`);
      if (result != "" && result != undefined) {
        this.loadingDialogService.openDialog();      
        this.brandService.addBrand(result).then((brands) => {
            this.loadingDialogService.hideDialog();
            this.brands = brands as Array<Brand>;
            this.logger.debug("Update results:" + JSON.stringify(brands))
          }
        );
      }
    });
  }

  /**
   * Delete brand
   * @param brand Brand to delete.
   */
  delete(brand : Brand) {

    let dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: { setting: brand,  title : "Confirm Delete" },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "" && result != undefined) {
        this.loadingDialogService.openDialog();      
        this.brandService.deleteBrand(brand).then(
          next => {
            this.toastr.success(`Brand ${brand.name} deleted successfully.`, 'Brand Deleted');
            this.brandService.getBrands().then( ( brands ) => {
              this.loadingDialogService.hideDialog();
                this.brands = brands;
              }
            );
          },
          error => {
            this.loadingDialogService.hideDialog();
            this.logger.debug(error);
          }
        )
      }

    });

  }
}
